export default `ids-popup::part(popup) {
  padding-block: 0;
  width: 100%;
}

ids-popup[visible][animated] {
  transition: none;
}

.ids-date-picker-popup .ids-popup.menu {
  padding-block: 0;
}

ids-month-view {
  width: 100%;
}

#month-year-view-trigger {
  margin: 4px;
}

.ids-date-picker-popup {
  min-width: 350px;
}
.ids-date-picker-popup:not(.has-time) ids-month-view::part(table-container) {
  margin-bottom: 10px;
}
.ids-date-picker-popup ids-popup::part(popup) {
  padding-block: 0;
}
.ids-date-picker-popup .popup-footer:not(.hidden) {
  border-top: 1px solid var(--ids-date-picker-popup-footer-color-border);
  display: flex;
}
.ids-date-picker-popup .popup-footer:not(.hidden) ids-modal-button:not([hidden]) + ids-modal-button,
.ids-date-picker-popup .popup-footer:not(.hidden) .ids-modal-button:not([hidden]) + .ids-modal-button {
  border-left: 1px solid;
  border-left-color: var(--ids-date-picker-popup-footer-color-border);
}
.ids-date-picker-popup .popup-btn {
  width: 100%;
}

.ids-date-picker-content {
  position: relative;
}

ids-expandable-area {
  display: block;
}

ids-expandable-area:not([expanded]),
ids-expandable-area[expanded=false] {
  pointer-events: none;
}

ids-expandable-area::part(container) {
  margin: 0;
  padding: 0;
  height: 100%;
  position: absolute;
  z-index: 3;
  border: none;
  left: 0;
  width: 100%;
}

ids-expandable-area::part(header) {
  display: none;
}

ids-expandable-area::part(pane) {
  background-color: var(--ids-date-picker-color-background);
}

ids-expandable-area::part(footer) {
  display: none;
}

ids-expandable-area::part(pane-content) {
  margin-top: 0;
  height: 100%;
}

ids-time-picker-popup {
  display: flex;
  justify-content: center;
}
ids-time-picker-popup[hidden] {
  display: none;
}
ids-time-picker-popup[embeddable] {
  margin-top: -18px;
}

.month-year-container {
  width: 100%;
  margin-top: 4px;
  margin-bottom: auto;
  justify-content: center;
  display: flex;
  gap: 8px;
}

.btn-today::part(button) {
  padding-block: 7px;
  padding-inline: unset;
}

.btn-today-text {
  color: var(--ids-date-picker-popup-button-today-color-text);
}

.btn-previous::part(button),
.btn-next::part(button) {
  width: 34px;
  height: 34px;
}

.btn-previous {
  padding-inline-start: 8px;
  padding-block: 5px;
}

.btn-next {
  padding-inline-end: 8px;
  padding-block: 5px;
  padding-inline-start: 2px;
  margin-top: 2px;
}

.popup-btn-group.hidden {
  display: none;
}
.popup-btn-group .btn-today:has(~ .popup-btn:not([hidden]))::part(button) {
  width: 58px;
}

.today-btn-group.hidden {
  display: none;
}

.dropdown-text-trigger:focus-visible {
  outline: none !important;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
